import { NavCard } from "../../v2024/card"
import { Link } from "gatsby"
import React from "react"

export const ProductsSectionMobile = ({ menuItem, title, items, comparative, openMenuItem, selectOpenMenuItem, onLinkClick }) => {
    const handleMenu = () => {
        selectOpenMenuItem(menuItem)
        document.getElementById("menuItem").scrollIntoView({ behavior: "smooth" })
    }

    return (
        <div id="menuItem" className={`item ${openMenuItem === menuItem ? "item--active" : ""}`}>
            <div className="item__header" onClick={() => handleMenu()}>
                <h6 className="item__header__title">{title}</h6>
                <i className="icon-chevron-down"></i>
            </div>
            <div className="item__body">
                <div className="mobile__menu__section">
                    {items.map(item =>
                        <>
                            {item.section_items.map(element =>
                                element.color && <div key={element.url} onClick={onLinkClick}>
                                    <NavCard
                                        title={element.title} link={element.url} icon={element.image}
                                        description={element.description} noArrow colortype={element.color}
                                    />
                                </div>
                            )}
                        </>
                    )}
                </div>
                <div className="mobile__menu__section">
                    {items.map(item =>
                        <>
                            {item.section_items.map(element =>
                                !element.color && <div key={element.url} onClick={onLinkClick}>
                                    <NavCard
                                        title={element.title} link={element.url}
                                        description={element.description} size="sm"
                                    />
                                </div>
                            )}
                        </>
                    )}
                </div>
                <div className="mobile__menu__section mobile__menu__section--gray">
                    <span className="section__title">{comparative.section_title}</span>
                    <div className="section__links">
                        {comparative.section_items.map(element =>
                            <div key={element.url} onClick={onLinkClick}>
                                <Link to={element.url}>{element.title}</Link>
                            </div>
                        )}
                    </div>
                    <div onClick={onLinkClick}>
                        <Link className="section__view-more" to={comparative.see_all.url}>{comparative.see_all.text}</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}